import { sizes } from '@bnnvara/breakpoints';
import debounce from 'lodash/debounce';
import { useEffect, useState } from 'react';

function isWindowWidthLargerThen(minSize) {
  if (!process.browser) {
    return true;
  }

  return window.innerWidth >= minSize;
}

export function useIsDesktop(minSize = sizes.lg) {
  const [isDesktop, setIsDesktop] = useState(isWindowWidthLargerThen(minSize));
  const handleResize = debounce(() => {
    const newValue = isWindowWidthLargerThen(minSize);

    if (newValue !== isDesktop) {
      setIsDesktop(isWindowWidthLargerThen(minSize));
    }
  }, 300);

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  return isDesktop;
}
